import * as types from './types';
import { isSpecialist, getWhiteList, getPartnersAllowlist } from '../extractFromState';
import { getEscalatedTickets } from '../api/tickets';
import { chooseDefaultNominatedTicket } from '../util';
import { handleError } from 'services/ErrorService/ErrorService';
import { loadTicketIfExists, setLoading } from './index';
import { getEscalatedTabFilterParameters } from '../selectors/filters';
import * as creatorsSync from './creatorsSync';

export const changeSelectedBusinessesForEscalatedFilter = (businessIdList) => ({
  type: types.SET_SELECTED_BUSINESSES_FOR_ESCALATED_FILTER,
  businessIdList,
});

export const changeExcludeBusinessesForEscalatedFilter = (value) => ({
  type: types.SET_EXCLUDE_BUSINESSES_FOR_ESCALATED_FILTER,
  value,
});

export const changeCommunicationTypeForEscalatedFilter = (filterId) => ({
  type: types.SET_COMMUNICATION_TYPE_FOR_ESCALATED_FILTER,
  filterId,
});

export const clearEscalatedFilters = () => ({
  type: types.CLEAR_ESCALATED_FILTERS,
});

export const filterEscalatedTickets = (skipSelectingTicket = false) => {
  return async (dispatch, getState) => {
    const stateBeforeUpdate = getState();

    if (!isSpecialist(stateBeforeUpdate)) {
      return;
    }

    dispatch(setLoading(true, 'inbox'));

    try {
      const state = getState();
      const whiteList = getWhiteList(state);
      const partnersAllowlist = getPartnersAllowlist(state);
      const escalatedTickets = await getEscalatedTickets({
        ...getEscalatedTabFilterParameters(stateBeforeUpdate),
        whiteList,
        partnersAllowlist,
      });

      dispatch(creatorsSync.hydrateNominatedTickets(escalatedTickets));
      dispatch({
        type: 'START_ESCALATED_TICKET_LQ',
      });

      const stateAfterUpdate = getState();

      const selectedTicketId = chooseDefaultNominatedTicket(stateAfterUpdate);

      if (!skipSelectingTicket && selectedTicketId) {
        dispatch(loadTicketIfExists(selectedTicketId, 'nominated'));
      }
      dispatch(setLoading(false));
    } catch (error) {
      handleError({ error, showPopup: true });
      dispatch(setLoading(false));
    }
  };
};
